import { getConnection, SelectQueryBuilder } from 'typeorm';

export interface ILeftJoinAndExcludeParams {
  query: SelectQueryBuilder<any>;
  parentEntityName: string;
  childRelationName: string;
  childJoinedRelationAlias: string;
  entityNameToJoin: string;
  excludedFields: string[];
  bypass?: boolean;
}

export interface ILeftJoinAndExcludeResponse {
  selectQuery: SelectQueryBuilder<any>;
  childJoinedRelationAlias: string;
}

export const leftJoinAndExcludeFieldsFromQuery = (
  params: ILeftJoinAndExcludeParams
): ILeftJoinAndExcludeResponse => {
  try {
    if (params.bypass) {
      return {
        selectQuery: params.query.leftJoinAndSelect(
          `${params.parentEntityName}.${params.childRelationName}`,
          params.childJoinedRelationAlias
        ),
        childJoinedRelationAlias: params.childJoinedRelationAlias
      };
    }

    if (
      !params.query ||
      !params.excludedFields ||
      params.excludedFields.length === 0 ||
      !params.entityNameToJoin ||
      params.entityNameToJoin === '' ||
      !params.childJoinedRelationAlias ||
      params.childJoinedRelationAlias === '' ||
      !params.childRelationName ||
      params.childRelationName === '' ||
      !params.parentEntityName ||
      params.parentEntityName === ''
    ) {
      throw new Error('Invalid params');
    }

    const capitalizedEntity =
      params.entityNameToJoin.charAt(0).toUpperCase() + params.entityNameToJoin.slice(1);
    const connection = getConnection().entityMetadatas.find(
      (entity) => entity.name === capitalizedEntity
    );

    const entitityColumns = connection.columns.map((column) => {
      return column.propertyName;
    });

    const selectedColumns = entitityColumns.filter(
      (column) => !params.excludedFields.includes(column)
    );

    return {
      selectQuery: params.query
        .leftJoin(
          `${params.parentEntityName}.${params.childRelationName}`,
          params.childJoinedRelationAlias
        )
        .addSelect(
          selectedColumns.map((column) => {
            return `${params.childJoinedRelationAlias}.${column}`;
          })
        ),
      childJoinedRelationAlias: params.childJoinedRelationAlias
    };
  } catch (error) {
    return {
      selectQuery: params.query.leftJoinAndSelect(
        `${params.parentEntityName}.${params.childRelationName}`,
        params.childJoinedRelationAlias
      ),
      childJoinedRelationAlias: params.childJoinedRelationAlias
    };
  }
};

export const excludeFieldsFromQuery = (params: {
  query: SelectQueryBuilder<any>;
  entityName: string;
  excludedFields: string[];
  bypass?: boolean;
}): SelectQueryBuilder<any> => {
  if (params.bypass) {
    return params.query;
  }
  try {
    if (
      !params.query ||
      !params.excludedFields ||
      params.excludedFields.length === 0 ||
      !params.entityName ||
      params.entityName === ''
    ) {
      return params.query;
    }

    const capitalizedEntity =
      params.entityName.charAt(0).toUpperCase() + params.entityName.slice(1);
    const connection = getConnection().entityMetadatas.find(
      (entity) => entity.name === capitalizedEntity
    );

    const entitityColumns = connection.columns.map((column) => {
      return column.propertyName;
    });

    const selectedColumns = entitityColumns.filter(
      (column) => !params.excludedFields.includes(column)
    );

    return params.query.select(
      selectedColumns.map((column) => {
        return `${params.entityName}.${column}`;
      })
    );
  } catch (error) {
    return params.query;
  }
};
